import api from './api';

export async function provisionCampaignNumber({ areaCode } = {}) {
  const payload = {};
  if (areaCode != null && String(areaCode).length === 3) {
    payload.area_code = parseInt(String(areaCode), 10);
  }
  const { data } = await api.post('/api/phone/campaign-number', payload);
  return data;
}

export async function releaseCampaignNumber() {
  const { data } = await api.delete('/api/phone/campaign-number');
  return data;
}
